import type { BaseTranslation } from '../i18n-types';

export const blockedUsers = {
    dialog: {
        title: 'Block this user',
        subtitle: `Are you sure you want to block {displayName:string}?`,
        confirm: 'Block',
    },
    toast: {
        blocked: 'User blocked',
        unblocked: 'User unblocked',
    },
    userListItemTitle: {
        unblocked: 'Block user',
        blocked: 'Unblock user',
    },
    explanation: {
        blockedByYou: `This user was blocked by you. If you want to send messages <span class="link">unblock</span> this user.`,
        youBlocked: 'This user blocked you',
    },
    list: {
        title: 'Blocked users',
        empty: 'The list of your blocked users will be here',
    },
} satisfies BaseTranslation;

